import basicBlock from "./basic";
import standardBlock from "./standard";
import logicBlock from "./logic";

export const blockMap = {
  ...basicBlock,
  ...standardBlock,
  ...logicBlock,
};
